import { Form } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  workspaceInviteSchema,
  WorkspaceInviteFormValues,
} from "@/schemas/workspace-invite";
import SelectEmails from "./SelectEmails";
import SelectWorkspace from "./SelectWorkspace";
import Submit from "./Submit";

interface CreateInviteFormProps {
  onSuccess: () => void;
  workspace?: { name: string; id: number }; // When provided, workspace selector will be disabled with this workspace pre-selected (satisfies workspace requirement)
}

const CreateInviteForm = ({ onSuccess, workspace }: CreateInviteFormProps) => {
  const form = useForm<WorkspaceInviteFormValues>({
    resolver: zodResolver(workspaceInviteSchema),
    defaultValues: {
      workspace_id: workspace?.id,
      emails: [],
    },
    mode: "onBlur",
    reValidateMode: "onSubmit",
  });

  return (
    <Form {...form}>
      <SelectWorkspace workspace={workspace} />
      <SelectEmails />
      <Submit onSuccess={onSuccess} />
    </Form>
  );
};

// Example usage:
// <CreateInviteForm onSuccess={() => {}} /> // Normal usage with workspace selector enabled (workspace is required)
// <CreateInviteForm onSuccess={() => {}} workspace={{name: "My Workspace", id: 123}} /> // Workspace selector disabled with "My Workspace" pre-selected (workspace requirement pre-filled)

export default CreateInviteForm;
